exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-box[data-v-4d1cd9c4]{box-sizing:border-box;overflow:hidden}.edit-label[data-v-4d1cd9c4]{text-align:right}.edit-label-init[data-v-4d1cd9c4],.edit-label[data-v-4d1cd9c4]{vertical-align:middle;font-size:14px;color:#606266;padding:0 12px 0 0;outline:none;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4d1cd9c4","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LabelBox/LabelBox.vue
// module id = 96
// module chunks = 0